import { useUnmountEffect } from '@timelyapp/react';
import { batch, useDispatch } from 'react-redux';
import { matchPath } from 'react-router-dom';
import { setDefaultQuery } from 'redux/modules/superreports.actions';
import { clearReportDraft } from 'redux/modules/superreports.types';
import type { ThunkDispatch } from 'types/redux';

// Exported as a pure function so it can be tested directly without `vi.mock`
// against redux modules — see CLAUDE.md guidance on testable boundaries and
// the `isolate: false` mock-cache poisoning risk.
export const shouldClearReportDraft = (pathname: string, allowedPaths: Array<string>): boolean => {
  if (pathname.endsWith('/superreports/new')) return false;
  return !allowedPaths.some(path => pathname.includes(path) || matchPath(path, pathname));
};

export const useClearReportDraftOnLeave = (...allowedPaths: Array<string>) => {
  const dispatch = useDispatch<ThunkDispatch>();

  useUnmountEffect(() => {
    if (shouldClearReportDraft(window.location.pathname, allowedPaths)) {
      batch(() => {
        dispatch(clearReportDraft());
        dispatch(setDefaultQuery(undefined, { skipFetch: true }));
      });
    }
  });
};
